import ActionTypes from '@utils/deviceActions';
import { useMemo } from 'react';
import { DeviceActionProps } from '@components/Actions/ActionsModal/types';
import { IDevice } from '@pages/Assets/Inventory/types';

interface ManualActivationPayloadProps {
  action: ActionTypes.MANUAL_ACTIVATION;
  devices: {
    msisdn: string;
  }[];
}

interface AddCreditProps {
  devices: IDevice[];
  isUpload?: boolean;
}

const useManualActivation = ({
  devices,
  isUpload,
}: AddCreditProps): DeviceActionProps => {
  const payloadToSend = useMemo(
    (): ManualActivationPayloadProps => ({
      action: ActionTypes.MANUAL_ACTIVATION,
      devices: isUpload
        ? devices
        : devices?.map(device => ({
            msisdn: device.msisdn,
          })),
    }),
    [devices, isUpload],
  );

  return {
    steps: [],
    payloadToSend,
  };
};

export default useManualActivation;
